export default __webpack_public_path__ + "static/media/welcomeToBlustream.d5437860.svg";